import React from 'react';
import { GridSVG } from '../../@common_components/svgs/grid.svg';

type GridIconProps = { active?: boolean } & React.SVGProps<SVGSVGElement>;

const GridIcon: React.FC<GridIconProps> = ( props: GridIconProps ) => {
  const { active, ...restProps } = props;
  const classes = `w-5 h-5 fill-current ${ active ? 'text-red-500' : 'text-gray-400' }`.trim();
  return <GridSVG {...restProps} className={ classes } />;
};

export { GridIcon };
